import { useTranslation } from "react-i18next";

const TmdbAttribution = ({ className = "" }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <div className={`flex items-center justify-center gap-2 ${className}`}>
      <a
        href="https://www.themoviedb.org"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 group"
      >
        <img
          src="/tmdb-logo.svg"
          alt="TMDB"
          className="h-3 opacity-60 group-hover:opacity-100 transition-opacity"
        />
      </a>
      <p className="text-[10px] text-muted-foreground leading-tight max-w-[220px]">
        {t("misc.tmdbAttribution")}
      </p>
    </div>
  );
};

export default TmdbAttribution;
